import logo from '../assets/logo2.png';

const LayoutFooter = ({ setCurrentPage }) => {

  const handleNavigation = (page) => {
  setCurrentPage(page);
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

  return (
    <footer className="bg-gray-900 text-white">
      {/* Mapa */}
      <div className="h-80">
        <iframe 
          width="100%" 
          height="100%" 
          frameBorder="0" 
          scrolling="no" 
          marginHeight="0" 
          marginWidth="0" 
          src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d60575.25337483105!2d-70.08008876060484!3d18.394974811364705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x8ea560afe380644d%3A0x4cb70649d7867f13!2sR%20%26%20M%20Componentes%20Industriales%2C%20S.R.L.%2C%20Carretera%20S%C3%A1nchez%20Vieja%2C%20Bajos%20de%20Haina!3m2!1d18.394892199999997!2d-70.03887259999999!4m5!1s0x8ea560afe380644d%3A0x4cb70649d7867f13!2s9XV6%2BXC5%2C%20Carr.%20S%C3%A1nchez%20Vieja%2C%20Bajos%20de%20Haina%2091000!3m2!1d18.394892199999997!2d-70.03887259999999!5e0!3m2!1ses-419!2sdo!4v1749780185693!5m2!1ses-419!2sdo"
        >
        </iframe>
      </div>
      
      {/* Contenido footer */}
      <div className="py-16 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo y descripción */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <img src={logo} alt="R&M Componentes" className="h-12 mr-4"/>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Distribuidores líderes en componentes para automatización y controles industriales con presencia nacional, comprometidos con la calidad y la innovación.
            </p>
            <p className="text-gray-400 leading-relaxed">
              Calidad y procesos, garantizando la excelencia en cada paso.
            </p>
          </div>


        
          
          {/* Enlaces rápidos */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-4">
              <li>
                <button onClick={() => handleNavigation('home')} className="text-gray-400 hover:text-white transition-colors text-lg">
                Inicio
              </button>
            </li>
            <li>
              <button onClick={() => handleNavigation('about')}  className="text-gray-400 hover:text-white transition-colors text-lg">
              Sobre Nosotros
               </button>
            </li>
            <li>
              <button onClick={() => handleNavigation('services')} className="text-gray-400 hover:text-white transition-colors text-lg">
              Productos
            </button>
            </li>
            <li>
              <button onClick={() => handleNavigation('news')} className="text-gray-400 hover:text-white transition-colors text-lg">
              Novedades
            </button>
            </li>
            <li>
              <button onClick={() => handleNavigation('contact')} className="text-gray-400 hover:text-white transition-colors text-lg">
              Contactos
               </button>
            </li>
            <li>
              <button onClick={() => handleNavigation('catalogo')}  className="text-gray-400 hover:text-white transition-colors text-lg">
              Catálogo 2024
              </button>
            </li>
            </ul>
          </div>
          
          {/* Contacto footer */}
          <div>
            <h4 className="text-xl font-semibold mb-6">Contacto</h4>
            <address className="not-italic text-gray-400 space-y-4">

              {/* Ubicación */}
              <p className="flex items-center leading-relaxed">
                <svg className="h-5 w-5 text-red-600 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
                </svg>
                Carretera Sanchez Vieja, Bajos de Haina. San Cristobal 91000, Santo Domingo
              </p>
              <p className="leading-relaxed"></p>

              {/* Teléfono */}
              <p className="flex items-center leading-relaxed">
                <svg className="h-5 w-5 text-red-600 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.48 2.53.74 3.88.74a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 21 3 13.93 3 5.5a1 1 0 011-1H7.5a1 1 0 011 1c0 1.35.26 2.67.74 3.88a1 1 0 01-.21 1.11l-2.2 2.2z" />
                </svg>
                Tel: (809) 957 1865
              </p>

              {/* Email */}
              <p className="flex items-center leading-relaxed">
                <svg className="h-5 w-5 text-red-600 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 2v.01L12 13 4 6.01V6h16zM4 18V8l8 5 8-5v10H4z" />
                </svg>
                Email: ventas@rmcomponentes.com
              </p>

            </address>
          </div>

        </div>
      </div>
      
      {/* Copyright */}
      <div className="bg-gray-800 py-6 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © TSP COMPANY AB. Todos los derechos reservados.
          </p>
          <div className="flex space-x-8">
            <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm">Términos y Condiciones</a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm">Política de Privacidad</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default LayoutFooter;